import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaStar,
  FaBriefcase,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const CorporateVideoProductionInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Corporate Video Production in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Elevate Your Corporate Brand</Subheading>}
        heading={
          <Heading>
            Professional{" "}
            <span tw="text-primary-500">Corporate Video Production</span> in Al
            Barsha
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, our corporate video production services in **Al
            Barsha** deliver polished, high-impact videos that enhance your
            brand’s professionalism and engage your audience. From corporate
            promos to training videos, we craft content that drives results.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1505236858219-8359eb29e329?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2662&q=80", // Professional video production setup
          "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Team collaboration in office
          "https://images.unsplash.com/photo-1552581234-26160f608093?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Modern corporate environment
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Project"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Corporate Video Production in Al Barsha"
        description="We create corporate videos that combine professionalism with strategic impact."
        cards={[
          {
            icon: <FaBriefcase color="#ff5464" size={40} />,
            title: "Professional Quality",
            description:
              "Polished videos that reflect your corporate identity.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Engaging Narratives",
            description: "Stories that connect with clients and stakeholders.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Timely Delivery",
            description: "Efficient production without compromising quality.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Multi-Platform Ready",
            description:
              "Optimized for websites, presentations, and social media.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "Al Barsha’s choice for corporate videography.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Comprehensive Production",
            description: "From concept to final edit, we handle everything.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Corporate Video Production Process"
        description={
          <Description>
            We deliver professional corporate videos through a streamlined
            process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your brand and objectives.</li>
              <li>Scripting: Develop a clear, impactful storyline.</li>
              <li>
                Filming: Capture high-quality footage with professional
                equipment.
              </li>
              <li>
                Editing: Enhance with effects, sound, and branding elements.
              </li>
              <li>Review: Ensure the video aligns with your vision.</li>
              <li>Delivery: Provide polished content for your platforms.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1570913196677-6121448dd763?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Video cameras and equipment
          "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Video editing workspace
          "https://images.unsplash.com/photo-1531884070720-875c7622d4c6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Team shooting a corporate video
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Corporate Video Wins in Al Barsha"
        description="Our corporate videos have elevated brands across Al Barsha."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Brand Engagement",
            description: "Increased client interaction with a corporate promo.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Stakeholder Trust",
            description: "Enhanced credibility for an Al Barsha business.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "96% approval from corporate clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Professional Videos?</Subheading>}
        heading="Corporate Video Production in Al Barsha"
        description={
          <Description>
            Partner with MilaajBrandset for professional corporate video
            production in Al Barsha. Create high-impact videos that elevate your
            brand and engage your audience—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1581092335397-9583eb92d232?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Dubai skyline/business district
          "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Business meeting/presentation
          "https://images.unsplash.com/photo-1621619856624-42fd193a0661?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2674&q=80", // Professional video filming equipment
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
